import React, { Fragment, useState } from 'react';

import { Button, Typography } from 'antd';

import { Show } from 'lib/Show';
import { Guest } from 'types/Guest.type';

import { GuestDetailsModal } from '../GuestDetailsModal';

type Props = { guest: Guest.Model };

export function GuestNameCell({ guest }: Props) {
    const [isDetailsModalVisible, setIsDetailsModalVisible] = useState(false);

    return (
        <Fragment>
            <Button
                type="link"
                style={{ '--ant-button-padding-inline': 0 }}
                onClick={() => setIsDetailsModalVisible(true)}
            >
                <Typography.Text
                    // We want the `Button#link` text color
                    style={{ '--ant-color-text': 'none' }}
                    ellipsis
                >
                    {guest.name}
                </Typography.Text>
            </Button>

            <Show when={isDetailsModalVisible}>
                <GuestDetailsModal
                    guest={guest}
                    onCancel={() => setIsDetailsModalVisible(false)}
                />
            </Show>
        </Fragment>

    );
}
